import { useContext } from 'react'

import { type AudioPlayerContext, audioPlayerContext } from '../providers/AudioPlayerProvider'

export const useAudioPlayer = (): AudioPlayerContext => useContext(audioPlayerContext)
